import React from 'react';

import { Box, Center, HStack, Stack } from '@chakra-ui/react';
import dayjs from 'dayjs';
import { each, map, upperFirst } from 'lodash';

import {
  CustomTooltip,
  getProviderAlias,
  Tag,
  WithResourceIcon,
} from 'components/DataDisplay';
import {
  CheckmarkCircleOutlineIcon,
  CloseCircleOutlineIcon,
  IconTypes,
} from 'components/Icons';
import { getIcon } from 'components/Icons/Components';

import { colorOpacity, customTheme } from '../../../../../../../theme';

export const renderClouds = (
  account_ids,
  type,
  accountMapping,
  showIcon = false,
) => {
  let items: Record<string, any[]> = {};
  each(account_ids, o => {
    const account = accountMapping?.[o];
    if (!!items?.[account?.cloud_type!])
      items[account?.cloud_type!].push(account);
    else items[account?.cloud_type!] = [account];
  });
  const clouds = Object.keys(items);
  const renderIcon = type => <Box boxSize={5}>{getIcon(type)}</Box>;
  if (type === 'clouds')
    return <HStack>{map(clouds, o => renderIcon(o))}</HStack>;
  /*return (
      <Stack spacing={0}>
        <HStack>
          {clouds?.[0] && renderIcon(clouds?.[0])}
          {clouds?.[1] && renderIcon(clouds?.[1])}
          {clouds?.[2] && renderIcon(clouds?.[2])}
        </HStack>
        <HStack>
          {clouds?.[3] && renderIcon(clouds?.[3])}
          {clouds?.[4] && renderIcon(clouds?.[4])}./
          {clouds?.length > 5 && <Tag label={'+ ' + (clouds?.length - 5)} />}
        </HStack>
      </Stack>
    );*/

  const renderAccount = () =>
    account_ids?.length +
    (showIcon ? ' account' + (account_ids?.length === 1 ? '' : 's') : '');

  return showIcon ? (
    <WithResourceIcon
      resourceType={IconTypes.Account}
      useCustomColor
      color={customTheme.colors.gray['300']}
      bgColor={colorOpacity(customTheme.colors.gray['300'], 0.2)}
      tooltip={
        <Stack spacing={4}>
          {map(items, (accounts, cloud) => (
            <Stack spacing={0}>
              <HStack align="flex-start" pb={2}>
                <Box>{getProviderAlias(cloud)}</Box>
                <Box boxSize={5}>{getIcon(cloud)}</Box>
              </HStack>
              {map(accounts, (account, index) => (
                <HStack align="start">
                  <Box whiteSpace="nowrap">{index + 1}.</Box>
                  <Box>
                    {account?.name + ' (' + account?.cloud_account_id + ')'}
                  </Box>
                </HStack>
              ))}
            </Stack>
          ))}
        </Stack>
      }
    >
      {renderAccount()}
    </WithResourceIcon>
  ) : (
    renderAccount()
  );
};

export const renderBusinessCritical = value => (
  <Center>
    <Center boxSize={5} color="primary">
      {value ? <CheckmarkCircleOutlineIcon /> : <CloseCircleOutlineIcon />}
    </Center>
  </Center>
);

export const renderExpiresIn = ({ row }) =>
  !!row?.nearest_expire_at ? (
    <HStack>
      <Box>{upperFirst(dayjs().to(dayjs(row?.nearest_expire_at)))}</Box>
    </HStack>
  ) : (
    'Never'
  );
